// import React, { useState } from 'react'
// import { Button, Card, CardContent, Divider, Grid, TextField } from '@mui/material'
// import { SearchOutlined } from '@mui/icons-material'
// import { Formik } from 'formik'
// import { NeedsClusterRemovedDetailsDto, needsClusterRemovedDetailsValidationSchema, NeedsToBeMovedToStagingDetailsDto, VehicleDto } from 'dtos'
// import { LabelField, GreenText } from 'components'
// import * as controllers from 'controllers'
// import { useLayout } from 'context'
// import { useParams } from 'react-router-dom'
// import NeedsToBeMovedToStagingStepper from './NeedsToBeMovedToStagingStepper'

// interface Step1PrepVehicleForOutboundTripProps {
//   initialValues: NeedsToBeMovedToStagingDetailsDto
//   onNext: (values: NeedsToBeMovedToStagingDetailsDto) => void
//   vehicle: VehicleDto
// }

// export default function Step1PrepVehicleForOutboundTrip({ initialValues, onNext, vehicle }: Step1PrepVehicleForOutboundTripProps) {
//   const layout = useLayout()
//   const { vehicleGuid } = useParams()

//   const [search, setSearch] = useState<string>('')
//   const [searchError, setSearchError] = useState<string>('')
//   const [hasSearched, setHasSearched] = useState<boolean>(false)

//   const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearch(e.target.value)
//   }

//   // const searchVehicle = (setValues: any) => {
//   //   layout.setIsLayoutLoading(true)
//   //   controllers
//   //     .getNeedsToBeMovedToStagingSearch(search)
//   //     .then(response => {
//   //       if (response.value) {
//   //         const vehicleLast6OfVin = vehicle.vin?.slice(-6)
//   //         if (search === vehicleLast6OfVin || search === vehicle.importerStockNumber) {
//   //           setValues(response.value)
//   //           setHasSearched(true)
//   //           setSearch('')
//   //           setSearchError('')
//   //         } else {
//   //           setValues(new VehicleDto())
//   //           setHasSearched(false)
//   //           setSearchError('Entered VIN does not match the last 6 of the VIN or Importer Stock #')
//   //         }
//   //       } else {
//   //         setValues(new VehicleDto())
//   //         setHasSearched(false)
//   //         setSearchError('No results found')
//   //       }
//   //     })
//   //     .finally(() => {
//   //       layout.setIsLayoutLoading(false)
//   //     })
//   // }

//   const searchVehicle = (setValues: any) => {
//     layout.setIsLayoutLoading(true)
//     controllers
//       .getNeedsToBeMovedToStagingSearch(search)
//       .then(response => {
//         if (response.value) {
//           const last6OfVin = response.value.vin?.slice(-6)
//           if (search === last6OfVin || search === response.value.importerStockNumber) {
//             setValues(response.value)
//             setHasSearched(true)
//             setSearch('')
//             setSearchError('')
//           } else {
//             setValues(new VehicleDto())
//             setHasSearched(false)
//             setSearchError('Entered VIN does not match the last 6 of the VIN or Importer Stock #')
//           }
//         } else {
//           setValues(new VehicleDto())
//           setHasSearched(false)
//           setSearchError('No results found')
//         }
//       })
//       .finally(() => {
//         layout.setIsLayoutLoading(false)
//       })
//   }

//   return (
//     <Formik
//       enableReinitialize={true}
//       initialValues={initialValues}
//       onSubmit={(values, formikHelpers) => {
//         controllers.vehicles
//           .prepVehicleForOutboundTrip(vehicleGuid!)
//           .then(() => {
//             onNext(values)
//           })
//           .finally(() => {
//             formikHelpers.setSubmitting(false)
//           })
//       }}
//       validateOnBlur={false}
//       validateOnChange={false}
//       // validationSchema={needsToBeMovedToStagingValidationSchema}
//     >
//       {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, setValues, touched, setTouched, values, validateForm }) => (
//         <form onSubmit={handleSubmit}>
//           <Card>
//             <CardContent>
//               <Grid container spacing={1} alignItems='center'>
//                 <Grid item xs={12}>
//                   <NeedsToBeMovedToStagingStepper activeStep={0} />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Divider />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <TextField
//                     autoFocus
//                     error={Boolean(searchError)}
//                     helperText={searchError}
//                     fullWidth
//                     label='Last 6 of VIN or Importer Stock #'
//                     onChange={handleSearchChange}
//                     value={search}
//                     onKeyDown={e => {
//                       if (e.key === 'Enter') {
//                         searchVehicle(setValues)
//                       }
//                     }}
//                   />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Button endIcon={<SearchOutlined />} color='primary' fullWidth onClick={() => searchVehicle(setValues)} variant='contained'>
//                     SEARCH
//                   </Button>
//                 </Grid>

//                 {hasSearched && vehicle && (
//                   <>
//                     <Grid item xs={12}>
//                       <LabelField label='VIN' value={vehicle?.vin} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Year' value={vehicle?.year} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Make' value={vehicle?.make} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Model' value={vehicle?.model} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField
//                         label='Exporter/Buyer'
//                         value={[vehicle?.exporterCompany?.name, vehicle?.buyerCompany?.name].filter(name => name).join(' / ') || '-'}
//                       />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Ready For Outbound Date' value={vehicle?.readyForOutboundDateTime} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Vehicle Release Date' value={vehicle?.vehicleReleaseDateTime} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Bond Release Date' value={vehicle?.bondReleaseDateTime} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Outbound Trip #' value={vehicle?.outboundTrip?.outboundTripNumber} />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <LabelField label='Outbound Trip Date' value={vehicle?.outboundTrip?.outboundTripDate} />
//                     </Grid>
//                   </>
//                 )}

//                 <Grid item xs={12} marginTop={1}>
//                   <Button color='primary' fullWidth type='submit' variant='contained' disabled={!hasSearched || !values.vin}>
//                     Prep Vehicle For Outbound Trip
//                   </Button>
//                 </Grid>

//                 <Grid item xs={12} marginTop={1}>
//                   <GreenText variant='outlined'>
//                     {`**Vehicle Steps:**

// Displays the current step of the vehicle in the Needs To Be
// Moved To Staging Process.

// **Last 6 of VIN/Importer Stock Number Search:**

// A free-text input field for entering either the last six
// characters of the VIN or the Importer Stock Number of a
// vehicle.

// **SEARCH Button:**

// Clicking the Search button performs a check to match the
// entered Last 6 of VIN or Importer Stock Number with the
// currently selected vehicle.

// If a match is found, the VIN, Year, Make, and Model fields
// will auto-populate with the vehicle’s details.

// If no match is found, red text will appear, displaying: “No
// Match Found.”

// **VIN:**

// A read-only label that displays the VIN of the searched
// vehicle.

// By default, the field displays a “-” if no vehicle has been
// found.

// **Year:**

// A read-only label that displays the Year of the searched
// vehicle.

// By default, the field displays a “-” if no vehicle has been
// found.

// **Make:**

// A read-only label that displays the Make of the searched
// vehicle.

// By default, the field displays a “-” if no vehicle has been
// found.

// **Model:**

// A read-only label that displays the Model of the searched
// vehicle.

// By default, the field displays a “-” if no vehicle has been
// found.

// **Exporter/Buyer:**

// Displays the Buyer company name if one is associated
// with the vehicle. If no Buyer is assigned, the Exporter
// company name is shown instead.

// **Ready For Outbound Date:**

// Read from the Conformity Details card under Vehicle
// Details – Conformity (tab). This date allows vehicles to be
// added to Outbound Trips before the Vehicle Release Date
// is reached (the 30-day DOT hold expires).

// **Vehicle Release Date:**

// Read from the Conformity Details card under Vehicle
// Details – Conformity (tab). This is the date that the DOT-
// mandated vehicle hold expires (typically 30 days after
// submission).

// **Bond Release Date:**

// Read from the Outbound Trip card under Vehicle Details –
// Conformity (tab). This field is nullable and may not be
// present for all vehicles. If the Bond Release Date is a past
// or current date, the vehicle can immediately be added to an
// Outbound Trip, regardless of the Ready For Outbound Date
// or Vehicle Release Date.

// **Outbound Trip #:**

// Displays the unique identifier of the Outbound Trip to
// which the vehicle is assigned.

// **Outbound Trip Date:**

// Displays the scheduled date of the Outbound Trip.

// **PREP VEHICLE FOR OUTBOUND TRIP Button:**

// Clicking this button will:

// Save the name of the user who pressed the button along
// with the date and time to the database.

// Advance the user to the next step in the process.

// This button is only enabled if the search for the Last 6 of
// VIN or Importer Stock Number results in a match.

// `}
//                   </GreenText>
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>
//         </form>
//       )}
//     </Formik>
//   )
// }

import React, { useState } from 'react'
import { Button, Card, CardContent, Divider, Grid, TextField } from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import { Formik } from 'formik'
import { NeedsClusterRemovedDetailsDto, needsClusterRemovedDetailsValidationSchema, NeedsToBeMovedToStagingDetailsDto, VehicleDto } from 'dtos'
import { LabelField, GreenText } from 'components'
import * as controllers from 'controllers'
import { useLayout } from 'context'
import { useParams } from 'react-router-dom'
import NeedsToBeMovedToStagingStepper from './NeedsToBeMovedToStagingStepper'
import { formatDate } from 'utils'

interface Step1PrepVehicleForOutboundTripProps {
  initialValues: NeedsToBeMovedToStagingDetailsDto
  onNext: (values: NeedsToBeMovedToStagingDetailsDto) => void
}

export default function Step1PrepVehicleForOutboundTrip({ initialValues, onNext }: Step1PrepVehicleForOutboundTripProps) {
  const layout = useLayout()
  const { vehicleGuid } = useParams()

  const [search, setSearch] = useState<string>('')
  const [searchError, setSearchError] = useState<string>('')
  const [hasSearched, setHasSearched] = useState<boolean>(false)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
  }

  const searchVehicle = (setValues: any) => {
    layout.setIsLayoutLoading(true)
    controllers
      .getNeedsToBeMovedToStagingSearch(search)
      .then(response => {
        if (response.value) {
          const last6OfVin = response.value.vin?.slice(-6)
          if (search === last6OfVin || search === response.value.importerStockNumber) {
            setValues(response.value) // ✅ set Formik values directly
            setHasSearched(true)
            setSearch('')
            setSearchError('')
          } else {
            setValues({} as NeedsToBeMovedToStagingDetailsDto)
            setHasSearched(false)
            setSearchError('Entered VIN does not match the last 6 of the VIN or Importer Stock #')
          }
        } else {
          setValues({} as NeedsToBeMovedToStagingDetailsDto)
          setHasSearched(false)
          setSearchError('No results found')
        }
      })
      .finally(() => {
        layout.setIsLayoutLoading(false)
      })
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        controllers.vehicles
          .prepVehicleForOutboundTrip(vehicleGuid!)
          .then(() => {
            onNext(values)
          })
          .finally(() => {
            formikHelpers.setSubmitting(false)
          })
      }}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ handleSubmit, isSubmitting, setValues, values }) => (
        <form onSubmit={handleSubmit}>
          <Card>
            <CardContent>
              <Grid container spacing={1} alignItems='center'>
                <Grid item xs={12}>
                  <NeedsToBeMovedToStagingStepper activeStep={0} />
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    autoFocus
                    error={Boolean(searchError)}
                    helperText={searchError}
                    fullWidth
                    label='Last 6 of VIN or Importer Stock #'
                    onChange={handleSearchChange}
                    value={search}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        searchVehicle(setValues)
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button endIcon={<SearchOutlined />} color='primary' fullWidth onClick={() => searchVehicle(setValues)} variant='contained'>
                    SEARCH
                  </Button>
                </Grid>

                {hasSearched && values && (
                  <>
                    <Grid item xs={12}>
                      <LabelField label='VIN' value={values?.vin} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Year' value={values?.year} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Make' value={values?.make} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Model' value={values?.model} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Exporter/Buyer' value={values?.exporterCompany?.name || values?.buyerCompany?.name || '-'} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Ready For Outbound Date' value={formatDate(values?.readyForOutboundDateTime)} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Vehicle Release Date' value={formatDate(values?.vehicleReleaseDateTime)} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Bond Release Date' value={formatDate(values?.bondReleaseDateTime)} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Outbound Trip #' value={values?.outboundTrip?.outboundTripNumber} />
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField label='Outbound Trip Date' value={formatDate(values?.outboundTrip?.outboundTripDate)} />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} marginTop={1}>
                  <Button color='primary' fullWidth type='submit' variant='contained' disabled={!hasSearched || !values?.vin}>
                    Prep Vehicle For Outbound Trip
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  )
}
